<template>
    <div class="">
        <ul>
            <li class="u-title">
                <i class="el-icon-bank-card menu-icon"></i>
                个人中心
            </li>
            <li>
                <router-link to="/user">个人信息</router-link>
            </li>
            <li>
                <router-link to="/user/address">地址管理</router-link>
            </li>
            <li>
                <router-link to="/user/safe">安全设置</router-link>
            </li>
        </ul>
        <ul>
            <li class="u-title">
                <i class="el-icon-s-cooperation menu-icon"></i>
                交易中心
            </li>
            <li>
                <router-link to="/user/order">我的订单</router-link>
            </li>
        </ul>
        <ul v-if="false">
            <li class="u-title">
                <i class="el-icon-star-off menu-icon"></i>
                关注中心
            </li>
            <li>我的收藏</li>
            <li>我的足迹</li>
        </ul>
        <ul v-if="false">
            <li class="u-title">
                <i class="el-icon-money menu-icon"></i>
                资产中心
            </li>
            <li>账户余额</li>
        </ul>
        <ul v-if="false">
            <li class="u-title">
                <i class="el-icon-office-building menu-icon"></i>
                分销中心
            </li>
            <li>我的推广</li>
            <li>我的收益</li>
        </ul>

    </div>
</template>
<script>
export default {
  name: 'UsermenuComponent',
  data () {
    return {
    }
  }
}
</script>
